'use strict';
/* eslint no-console: 0 */
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _envInfo = require('../constants/envInfo');

var _noAuthApiClient = require('../utils/http/noAuthApiClient');

var _noAuthApiClient2 = _interopRequireDefault(_noAuthApiClient);

var _Logger = require('../lib/Logger');

var _Logger2 = _interopRequireDefault(_Logger);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var LOG = _Logger2.default.getLogger('HubspotFormSubmissionDAO');

/*
 *   This DAO is for emulating a hubspot form submission
 */

var envSuffix = _envInfo.isProd ? '' : 'qa';
var FORMS_API = 'https://api.hsforms' + envSuffix + '.com/submissions/v3/integration/submit';
var PORTAL_ID = '250707';

var PORTAL_ID_QA = '99609805'; // qa portal 99609805
var FORM_ID_QA = '3a3e7354-7e33-487e-8884-f3d48d89775d'; // qa form 3a3e7354-7e33-487e-8884-f3d48d89775d

exports.default = {
  submitForm: function submitForm(_ref) {
    var _ref$formApi = _ref.formApi,
        formApi = _ref$formApi === undefined ? FORMS_API : _ref$formApi,
        _ref$portalId = _ref.portalId,
        portalId = _ref$portalId === undefined ? PORTAL_ID : _ref$portalId,
        formId = _ref.formId,
        data = _ref.data;

    var submitToForm = _envInfo.isProd ? formId : FORM_ID_QA;
    var submitToPortal = _envInfo.isProd ? portalId : PORTAL_ID_QA;
    var formPath = formApi + '/' + submitToPortal + '/' + submitToForm;

    return _noAuthApiClient2.default.post(formPath, {
      withCredentials: true,
      data: data.toJS()
    }).catch(function (error) {
      LOG.error('Form submission error', {
        extra: {
          error: error.data,
          formId: formId,
          portalId: portalId,
          data: data
        }
      });
    });
  }
};
module.exports = exports['default'];